import { requestLeave } from "@/lib/leaveRegistry";
import { CircleUser, ShieldCheck, Users, History, Image, Mail, Bell, Database, Cloud, Server, HeartPulse, Globe, CalendarOff, Building2 } from "lucide-react";

/** iter453 — Paramètres › barre d'onglets (modèle S1) : icône Lucide 16 px colorée sans fond + libellé 12 px ; tout futur onglet DOIT déclarer son icône ici. */
export const SETTINGS_TAB_ICONS = {
  account: [CircleUser, "#A78BFA"], security: [ShieldCheck, "#4ADE80"], users: [Users, "#3B9EFF"], history: [History, "#93B4F5"], brand: [Image, "#F472B6"],
  "email-prefs": [Mail, "#3B9EFF"], "notif-sound": [Bell, "#FBBF24"], storage: [Database, "#2DD4BF"], "backup-b2": [Cloud, "#60A5FA"], "backup-nas": [Server, "#C8C8CC"],
  health: [HeartPulse, "#F87171"], domain: [Globe, "#22C55E"], holidays: [CalendarOff, "#E24B4A"], projects: [Building2, "#A78BFA"],
};

export const TAB_CSS = `.st-tabs{display:flex;flex-wrap:wrap;align-items:center;padding:6px 8px;background:#141417;border:1px solid #26262C;border-radius:12px}
.st-tab{display:inline-flex;align-items:center;gap:7px;padding:7px 10px;border-radius:8px;font-size:12px;line-height:1.2;color:#9A9AA2;white-space:nowrap;background:transparent;transition:color .15s,background-color .15s}
.st-tab svg{width:16px;height:16px;flex-shrink:0;color:#6B6B73}
.st-tab:hover{background:#1B1B20;color:#C8C8CC}
.st-tab[data-active="true"]{color:#fff;background:var(--tab-bg);box-shadow:inset 0 -2px 0 var(--tab-color)}
.st-tab[data-active="true"] svg{color:var(--tab-color)}
.st-sep{width:1px;height:22px;background:linear-gradient(180deg,transparent,#34343C 50%,transparent);margin:0 2px;flex-shrink:0;align-self:center}`;

export function SettingsTab({ value, label, active, onSelect, testId }) {
  const [Icon, color] = SETTINGS_TAB_ICONS[value] || [];
  return (
    <button type="button" role="tab" aria-selected={active} className="st-tab" data-active={active} style={{ "--tab-color": color || "#7C5CE0", "--tab-bg": `${color || "#7C5CE0"}1A` }} onClick={() => requestLeave("page", () => onSelect(value))} data-testid={testId}>
      {Icon && <Icon size={16} aria-hidden="true" />}{label}
    </button>
  );
}

/** Barre complète : séparateurs entre onglets, masqués en début de ligne (retour à la ligne). */
export function SettingsTabBar({ tabs, active, onSelect, testId = "settings-tabs" }) {
  const hideLineStartSeps = (el) => {
    if (!el) return;
    const items = [...el.querySelectorAll(".st-tab")];
    el.querySelectorAll(".st-sep").forEach((sep, i) => { const prev = items[i], next = items[i + 1]; sep.style.visibility = prev && next && Math.abs(prev.offsetTop - next.offsetTop) > 4 ? "hidden" : "visible"; });
  };
  return (
    <div role="tablist" className="st-tabs" ref={(el) => { hideLineStartSeps(el); if (el && !el.__ro && typeof ResizeObserver !== "undefined") { el.__ro = new ResizeObserver(() => hideLineStartSeps(el)); el.__ro.observe(el); } }} data-testid={testId}>
      {tabs.map(([v, l], i) => (
        <span key={v} className="contents">
          {i > 0 && <span className="st-sep" aria-hidden="true" data-testid={`tab-sep-${v}`} />}
          <SettingsTab value={v} label={l} active={active === v} onSelect={onSelect} testId={`tab-${v}`} />
        </span>))}
    </div>
  );
}
